import { ChevronDown, ChevronUp, SortDown } from 'react-bootstrap-icons';
import clsx from 'clsx';
import React from 'react';
import { FilterOptionValue } from '@mybestbrands/types';
import Link from 'next/link';
import styles from './filters.module.scss';
import { usePathname, useSearchParams } from 'next/navigation';
import { useTranslation } from 'next-i18next';

export function SortingFilter({
  filter,
  isActive,
  toggleFilterOptions,
}: {
  filter: FilterOptionValue | undefined;
  isActive: boolean;

  toggleFilterOptions: (val: boolean) => void;
}) {
  const { t } = useTranslation('filters');
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const createPageURL = (sort: string) => {
    const params = new URLSearchParams(searchParams ?? '');
    const page = params.get('page');

    //We have to remove the page param when we change the sorting
    if (page) params.delete('page');

    //update sort param
    params.set('sort', sort.toString());
    return `${pathname}?${params.toString()}`;
  };
  const Chevron = isActive ? ChevronUp : ChevronDown;

  if (!filter) return null;

  return (
    <div
      key={filter.name}
      className="position-relative"
      style={{
        zIndex: 3,
      }}>
      <div
        onClick={() => toggleFilterOptions(!isActive)}
        key={filter.name}
        className={`btn btn-white-hover-black lowercase d-flex justify-content-center align-items-center ${styles.filter}`}>
        <span>{t(filter.name)}</span>
        <Chevron data-testid="chevron-icon" className={clsx(`ms-2`, isActive ? 'chevron-up' : 'chevron-down')} />
      </div>
      {isActive && (
        <div
          className="position-absolute bg-white border border-dark"
          style={{ top: '35px', left: 0, width: '9rem', minWidth: '11rem' }}>
          <div className={`d-flex flex-column p-2 ${styles.option}`}>
            {filter.options.map((option) => (
              <div key={option.id} className="d-flex align-items-center mb-2">
                <Link href={createPageURL(option.value)} onClick={() => toggleFilterOptions(false)}>
                  <label
                    className={`${clsx(
                      'cursor-pointer me-3 text-decoration-none text-black',
                      styles.optiionlabel,
                      option.checked ? 'fw-bold' : ''
                    )}`}>
                    {t(option.name)}
                  </label>
                </Link>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
